<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    :width="popupWidth"
    @close="dialogClose"
    v-dialogDrag
    append-to-body
  >
    <slot></slot>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="cancel">取 消</el-button>
      <el-button type="success" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  // name: "commonDialog",
	props:{
		dialogTitle: {
      type: String,
      default: '标题'
    },
		visible: {
      type: Boolean,
      default: false
    },
		popupWidth: {
      type: String,
      default: '550px'
    }
	},
  data() {
    return {

    };
  },
   computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        // 当visible改变的时候，触发父组件的 updateVisible方法，在该方法中更改传入子组件的 centerDialogVisible的值
        this.$emit('updateVisible', val)
      }
    }
  },
  methods: {
		// 关闭弹窗x
		dialogClose(){
			this.$emit('dialogClose')
		},
		// 弹窗的取消按钮
		cancel(){
			this.$emit('cancel')
		},
		// 弹窗的保存按钮
		save(){
			this.$emit('save')
		}
	},
  created() {},
  mounted() {},
};
</script>

<style scoped lang="less">
</style>